import { createSignal, onCleanup, type Accessor } from 'solid-js'

/** The device clock, re-read every second while the owner lives. */
export function createNow(): Accessor<number> {
  const [now, setNow] = createSignal(Date.now())
  const timer = setInterval(() => setNow(Date.now()), 1000)
  onCleanup(() => clearInterval(timer))
  return now
}
